import { QuestionCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import './index.less';
import className from 'classnames';

export default (props) => {
  const { size = 'middle', type = 'question', color = 'inherit', ...otherProps } = props;
  const _classNames = className({
    'TY_ICON-TIP--icon': true,
    [`size_${size}`]: true,
  });
  return (
    <Tooltip {...otherProps}>
      {type === 'info' ? (
        <InfoCircleOutlined className={_classNames} style={{ color }} />
      ) : (
        <QuestionCircleOutlined className={_classNames} style={{ color }} />
      )}
    </Tooltip>
  );
};
